import { useAIAssistantForPage } from '@euler/app/components/ai/pageContext';
import { OrderDetailBottomSheet } from '@euler/app/flows/order/components/OrderDetailBottomSheet';
import { useOrderDetailContext } from '@euler/app/flows/order/components/OrderDetailProvider';
import { useServiceRecordContext } from '@euler/app/flows/record/ServiceRecordContext';
import { ServiceRecordNavParams } from '@euler/app/flows/record/ServiceRecordFlow';
import { ServiceRecordDetailContent } from '@euler/app/flows/record/pages/detail/components/Content';
import { ServiceRecordDetailContentForIpad } from '@euler/app/flows/record/pages/detail/components/Content.iPad';
import { HeaderRight } from '@euler/app/flows/record/pages/detail/components/HeaderRight';
import { TaskDetailPageContainer } from '@euler/app/flows/task/pages/detail/components/DetailPageContainer';
import { useIsMobileLayout } from '@euler/functions/responsiveness';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { useCreation } from '@euler/utils/hooks';
import { useIsFocused, useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { useCallback } from 'react';
import { useSharedValue } from 'react-native-reanimated';
import { BehaviorSubject } from 'rxjs';

export const ServiceRecordScreen = wrapNavigatorScreen(
  () => {
    const { serviceRecord, loading, refreshing, refresh } =
      useServiceRecordContext();

    useAIAssistantForPage('service_record', {
      taskNo: serviceRecord?.taskNo,
      orderNo: serviceRecord?.orderNo,
    });

    const scrollY = useSharedValue(0);
    const isMobileLayout = useIsMobileLayout();

    const { orderDetail } = useOrderDetailContext();

    const showOrderDetail$ = useCreation(() => new BehaviorSubject(false), []);
    const navigation =
      useNavigation<StackNavigationProp<ServiceRecordNavParams>>();

    const isFocused = useIsFocused();

    const onShowDetail = useCallback(() => {
      if (isMobileLayout) {
        showOrderDetail$.next(true);
      } else {
        navigation.navigate('_orderDetail', {});
      }
    }, [isMobileLayout, navigation, showOrderDetail$]);

    return (
      <>
        <TaskDetailPageContainer
          isRefreshing={refreshing}
          licensePlateNo={serviceRecord.licensePlateNo}
          vehicleName={serviceRecord.vehicleName}
          vehicleImageUrl={serviceRecord.vehicleImageUrl}
          titleLoadingIndicator={loading}
          scrollY={scrollY}
          title="服务记录"
          subTitle="已完成交车"
          navBarRightOptions={() => <HeaderRight />}
          onRefresh={refresh}
          headerColors={
            serviceRecord.isMainRecord
              ? ['#0054ae', '#009FD4']
              : ['#B381B3', '#939393']
          }
        >
          {isMobileLayout ? (
            <ServiceRecordDetailContent
              orderDetail={orderDetail}
              onShowDetail={onShowDetail}
            />
          ) : (
            <ServiceRecordDetailContentForIpad
              orderDetail={orderDetail}
              onShowDetail={onShowDetail}
            />
          )}
        </TaskDetailPageContainer>
        {isMobileLayout && isFocused && (
          <OrderDetailBottomSheet
            visible$={showOrderDetail$}
            hideEstimatedFinishTime
          />
        )}
      </>
    );
  },
  {
    headerShown: false,
  },
);
